import * as React from 'react';
const SvgInfo = () =>
  /* @__PURE__ */ React.createElement(
    'svg',
    { width: 18, height: 18, fill: 'none' },
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      fillRule: 'evenodd',
      d: 'M2.059 9A6.941 6.941 0 1 0 15.94 9 6.941 6.941 0 0 0 2.06 9M9 1a8 8 0 1 0 0 16A8 8 0 0 0 9 1',
      clipRule: 'evenodd',
    }),
    /* @__PURE__ */ React.createElement('path', {
      fill: 'currentColor',
      d: 'M9.598 12.472V8.347a.672.672 0 0 0-1.344 0v4.125a.672.672 0 0 0 1.344 0M8.926 6.547a.846.846 0 1 0 0-1.691.846.846 0 0 0 0 1.691',
    }),
  );
export default SvgInfo;
